import { Injectable } from '@angular/core';
import { ListService } from 'bookraw/shared/services/list.service';
import { Config } from 'bookraw/shared/models/config.model';

@Injectable()
export class ConfigsService extends ListService<Config> {

  url: string = '/api/admin/configs';
}
